import React, { Fragment, Component } from "react";
import { Route, withRouter, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { func, bool, shape, string } from "prop-types";

import { actions as statusActions } from "reducers/status";
import { selectors as sessionSelectors } from "reducers/session";

import ChangeEmail from "pages/settings/ChangeEmail";
import ChangeEmailConfirmation from "pages/settings/ChangeEmailConfirmation";
import ChangeEnvironment from "pages/settings/ChangeEnvironment";
import SetDefaultEnvironment from "pages/settings/SetDefaultEnvironment";
import ChangePassword from "pages/settings/ChangePassword";
import ChangePhone from "pages/settings/ChangePhone";
import ChangePhoneConfirmation from "pages/settings/ChangePhoneConfirmation";
import ChangeSecuritySeal from "pages/settings/ChangeSecuritySeal";
import ChangeSecuritySealConfirmation from "pages/settings/ChangeSecuritySealConfirmation";
import LastLogin from "pages/settings/LastLogin";
import DefaultLayout from "pages/_layouts/DefaultLayout";
import AccountsFC from "pages/accounts/AccountsFC";
import FingerprintConfiguration from "pages/settings/FingerprintConfiguration";
import FingerprintDeleteConfirmation from "pages/settings/FingerprintDeleteConfirmation";
import PushNotifications from "pages/settings/PushNotifications";
import PushNotificationsDeleteConfirmation from "pages/settings/PushNotificationsDeleteConfirmation";
import MyDevices from "pages/settings/MyDevices";
import MyToken from "pages/settings/MyToken";
import QueryToken from "pages/settings/QueryToken";
import DocumentsIndex from "pages/settings/_esign/DocumentsIndex";
import EsignDocumentsSigned from "pages/settings/_esign/EsignDocumentsSigned";
import NotificationsConfiguration from "pages/settings/NotificationsConfiguration";
import NotificationsConfigurationTransports from "pages/settings/NotificationsConfigurationTransports";
import Settings from "pages/settings/Settings";
import Form from "pages/forms/Form";
import Transaction from "pages/forms/Transaction";
import SessionAboutToExpire from "pages/status/SessionAboutToExpire";
import BackButtonListener from "pages/_components/BackButtonListener";
import CreditCards from "pages/creditCards";
import CreditCardDetails from "pages/creditCards/Details";
import CreditrCardMovementDetails from "pages/creditCards/_components/MovementDetails";
import CreditCardAliasForm from "pages/creditCards/EditAlias";
import CreditCardMobileFilters from "pages/creditCards/MobileFilters";
import CreditCardMobileFilterResult from "pages/creditCards/MobileFilterResult";
import AccountDetail from "pages/accounts/Details";
import AccountStatements from "pages/accounts/_components/Statements";
import SetAlias from "pages/accounts/_components/SetAlias";
import Filters from "pages/accounts/_components/MobileFilters";
import Results from "pages/accounts/_components/MobileFiltersResults";
import Agreements from "pages/accounts/Agreements";
import Desktop from "pages/desktop/Desktop";
import PendingActions from "pages/desktop/PendingActions";
import Deposits from "pages/deposits/Deposits";
import Loans from "pages/loans/Loans";
import SolicitudDatos from "pages/loans/_components/SolicitudDatos";
import DetallePrestamo from "pages/loans/_components/loanDetail/DetallePrestamo";
import DetalleCuota from "pages/loans/_components/DetalleCuota";
import CancelacionAnticipada from "pages/loans/_components/CancelacionAnticipada";
import CancelacionAnticipadaTicket from "pages/loans/_components/CancelacionAnticipadaTicket";
import OtrosProductosSuccessTicket from "pages/loans/_components/OtrosProductosSuccessTicket";
import OtrosProductos from "pages/loans/_components/OtrosProductos";

import LoanDetails from "pages/loans/Details";
import LoanSetAlias from "pages/loans/_components/SetAlias";
import LoanMobileFilters from "pages/loans/_components/MobileFilters";
import LoanStatementDetail from "pages/loans/_components/StatementDetail";
import CreditCardsPaymentList from "pages/creditCardsPayment/List";
import LoansPaymentList from "pages/loansPayment/List";
import CommunicationMain from "pages/communications/Main";
import NewMessage from "pages/communications/NewMessage";
import ReadMessage from "pages/communications/ReadMessage";
import ReplyMessage from "pages/communications/ReplyMessage";
import PendingTransactionList from "pages/transactions/PendingTransactionList";
import TransactionsList from "pages/transactions/TransactionsList";
import TransactionsListFilters from "pages/transactions/_components/MobileFilters";
import TransactionsFiltersResults from "pages/transactions/_components/MobileFiltersResults";
import BankSearch from "pages/forms/_components/_fields/_bankselector/bankSearch/BankSearch";
import MobileTransfers from "pages/accounts/_components/MobileTransfers";
import PrivacyPolicy from "pages/_components/PrivacyPolicy";
import TermsAndConditions from "pages/_components/TermsAndConditions";
import SupportInfo from "pages/_components/SupportInfo";
import UserInvite from "pages/administration/UserInvite";
import UserInviteStep2 from "pages/administration/UserInviteStep2";
import UserInviteStep3 from "pages/administration/UserInviteStep3";
import Administration from "pages/administration/Administration";
import AdministrationMediumSignatureTicket from "pages/administration/medium/tickets/SignatureTicket";
import PointsOfInterest from "pages/pointsOfInterest";
import Templates from "pages/forms/_components/Templates";
import FormPaymentLines from "pages/forms/FormPaymentLines";
import TransactionPaymentLines from "pages/forms/TransactionPaymentLines";
import StepPEP from "pages/onboarding/_pages/StepPEP";
import StepIRS from "pages/enrollment/StepIRS";
import DepositDetails from "pages/deposits/Details";
import NewDepositRequestForm from "pages/deposits/NewDepositRequestForm";
import NewDepositSummaryForm from "pages/deposits/NewDepositSummaryForm";
import NewDepositPendingTransaction from "pages/deposits/NewDepositPendingTransaction";
import NewDepositSuccessTransaction from "pages/deposits/NewDepositSuccessTransaction";
import DepositRates from "pages/deposits/DepositRates";
import HistoricalDetails from "pages/deposits/HistoricalDetails";
import CustomMovementDetail from "pages/accounts/_components/CustomMovementDetail/CustomMovementDetail";
import NewAccountRequestForm from "pages/accounts/NewAccountRequestForm";
import NewAccountSummaryForm from "pages/accounts/NewAccountSummaryForm";
import PendingTransactionPage from "pages/accounts/PendingTransactionPage";
import SuccessTransactionPage from "pages/accounts/SuccessTransactionPage";
import NewCheckbookRequestForm from "pages/checks/NewCheckbookRequestForm";
import NewCheckbookSummaryForm from "pages/checks/NewCheckbookSummaryForm";
import NewCheckbookSuccessPage from "pages/checks/NewCheckbookSuccessPage";
import PendingBackofficeApprovePage from "pages/checks/PendingBackofficeApprovePage";
import PendingUserSignaturesPage from "pages/checks/PendingUserSignaturesPage";
import HistoricalBalances from "pages/accounts/HistoricalBalances";
import AgreementRequest from "pages/accounts/AgreementRequestPage";
import AgreementSummaryPage from "pages/accounts/AgreementRequestPage/AgreementSummaryPage";
import PendingAgreementPage from "pages/accounts/AgreementRequestPage/PendingAgreementPage";
import SuccessAgreementPage from "pages/accounts/AgreementRequestPage/SuccessAgreementPage";
import DepositCancelRenewal from "pages/deposits/DepositCancelRenewal";
import SuccessCancelRenewalPage from "pages/deposits/DepositCancelRenewal/SuccessCancelRenewalPage";
import PendingCancelRenewalPage from "pages/deposits/DepositCancelRenewal/PendingCancelRenewalPage";
import ForbidenCancelRenewalPage from "pages/deposits/DepositCancelRenewal/ForbidenCancelRenewalPage";
import EchecksPage from "pages/echeck/Echecks";
import DetailEcheck from "pages/echeck/Detail/DetailEcheck";
import EmitEcheckPage from "pages/echeck/EmitEcheck";
import EmitEcheckSummaryPage from "pages/echeck/EmitEcheck/SummaryPage";
import ConfirmEcheckPage from "pages/echeck/EcheckActions/ConfirmPage";
import EmitEcheckTransactionPage from "pages/echeck/EmitEcheck/TransactionPage";
import EmitDebinTransactionPage from "pages/debinPayments/AddRecurence/TransactionPage";
import EndorseEcheckPage from "pages/echeck/EndorseEcheck";
import EndorseSummaryPage from "pages/echeck/EndorseEcheck/SummaryPage";
import EndorseEcheckTransactionPage from "pages/echeck/EndorseEcheck/TransactionPage";
import EcheckMultipleTransactionPage from "pages/echeck/EndorseEcheck/MultipleTransactionPage";
import EmitCesionPage from "pages/echeck/EmitCesion";
import CesionSummaryPage from "pages/echeck/EmitCesion/SummaryPage";
import CesionEcheckTransactionPage from "pages/echeck/EmitCesion/TransactionPage";
import EcheckRequestPage from "pages/echeck/EcheckRequest";
import EcheckRequestSummaryPage from "pages/echeck/EcheckRequest/SummaryPage";
import ContactDestinationPage from "pages/frequentDestination";
import ContactDetailsPage from "pages/frequentDestination/Detail";
import NewContactPage from "pages/frequentDestination/NewContact";
import NewContactSummaryPage from "pages/frequentDestination/NewContactSummaryPage";
import ContactTransactionPage from "pages/frequentDestination/TransactionPage";
import AcceptReturnPage from "pages/echeck/AcceptReturnEcheck";
import ReturnTransactionPage from "pages/echeck/AcceptReturnEcheck/TransactionPage";
import ModifyContactPage from "pages/frequentDestination/ModifyContact";
import ModifySummaryPage from "pages/frequentDestination/ModifySummaryPage";
import StepStart from "pages/environment/StepStart/StepStart";
import StepGeneralData from "pages/environment/StepGeneralData/StepGeneralData";
import StepTaxData from "pages/environment/StepTaxData/StepTaxData";
import StepLegalRepresentative from "pages/environment/StepLegalRepresentative/StepLegalRepresentative";
import StepShareholders from "pages/environment/StepShareholders/StepShareholders";
import StepProxies from "pages/environment/StepProxies/StepProxies";
import StepBeneficiaries from "pages/environment/StepBeneficiaries/StepBeneficiaries";
import StepDocumentation from "pages/environment/StepDocumentation/StepDocumentation";
import StepFinish from "pages/environment/StepFinish/StepFinish";
import StepAcceptPayway from "pages/environment/StepAcceptPayway/StepAcceptPayway";
import StepSelectPaywayTerminalType from "pages/environment/StepSelectPaywayTerminalType/StepSelectPaywayTerminalType";
import StepSelectPaywayCategory from "pages/environment/StepSelectPaywayCategory/StepSelectPaywayCategory";
import StepPaywayTerminals from "pages/environment/StepPaywayTerminals/StepPaywayTerminals";
import StepFinishPayway from "pages/environment/StepFinishPayway/StepFinishPayway";
import StepError from "pages/environment/StepError/StepError";
import DeleteSummaryPage from "pages/frequentDestination/DeleteSummaryPage";
import DebinPayments from "pages/debinPayments/IncomingDebinList";
import AddRecurenceDebin from "pages/debinPayments/AddRecurence";
import DebinConfirmePage from "pages/debinPayments/AddRecurence/SummaryPage";
import ReceivedDebinSumaryPage from "pages/debinPayments/DebinActions/ReceivedDebinSumaryPage";
import RejectDebinSumaryPage from "pages/debinPayments/DebinActions/RejectDebinSumaryPage";
import AnulateDebinSumaryPage from "pages/debinPayments/DebinActions/AnulateDebinSumaryPage";
import DetailRecurrentDebin from "pages/debinPayments/Detail/DetailRecurrentDebin";
import DetailReceibedDebin from "pages/debinPayments/Detail/DetailReceivedDebin";
import DetailIssuedDebin from "pages/debinPayments/Detail/DetailIssuedDebin";
import ActionsDebinSumaryPage from "pages/debinPayments/DebinActions/ActionsDebinSumaryPage";
import ActionsTransactionPage from "pages/debinPayments/DebinActions/ActionsTransactionPage";
import ChargeBackSummaryPage from "pages/debinPayments/ChargeBack/SummaryPage";
import Transfers from "pages/transfers";
import TransferSummaryPage from "pages/transfers/SummaryPage";
import AddAccountDebin from "pages/debinPayments/AddAccounts/AddAccountDebin";
import AddAccountConfirmation from "pages/debinPayments/AddAccounts/AddAccountConfirmation";
import SolicitDebin from "pages/debinPayments/SolicitDebin/SolicitDebin";
import SolicitDebinConfirmation from "pages/debinPayments/SolicitDebin/SolicitDebinConfirmation";
import SolicitDebinTransactionPage from "pages/debinPayments/SolicitDebin/SolicitDebinTransactionPage";
import payDebinPage from "pages/debinPayments/DebinActions/PayDebinSumaryPage";
import ScheduledDebinList from "pages/debinPayments/ScheduledDebin/ScheduledDebinList";
import ActionConfirmation from "pages/debinPayments/ScheduledDebin/ActionConfirmation";
import ActionTransactionPage from "pages/debinPayments/ScheduledDebin/ActionTransactionPage";
import ScheduledDebinDetail from "pages/debinPayments/ScheduledDebin/ScheduledDebinDetail";
import EcheckRequestTransactionPage from "pages/echeck/EcheckRequest/TransactionPage";
import TransferTransactionPage from "pages/transfers/TransactionIndex";
import LotPaymentsPage from "pages/payThirdParties";
import LotPaymentTransactionPage from "pages/payThirdParties/NewLotPayment/TransactionPage";
import NewLotPaymentPage from "pages/payThirdParties/NewLotPayment";
import SolicitAval from "pages/echeck/SolicitAval";
import SolicitAvalSumary from "pages/echeck/SolicitAval/SummaryPage";
import AnulateEcheckPage from "pages/echeck/EcheckActions/AnulatePage";
import ActionsAvalPage from "pages/echeck/ActionsAval/SummaryPage";
import NewLotPaymentSummaryPage from "pages/payThirdParties/NewLotPayment/SummaryPage";
import DiscountsPage from "pages/discounts";
import DiscountSimulationPage from "pages/discounts/DiscountSimulation";
import DiscountReviewPage from "pages/discounts/DiscountReview";
import DiscountReviewPartialsPage from "pages/discounts/DiscountReviewPartials";
import NewDiscountProcessingTransaction from "pages/discounts/NewDiscountProcessingTransaction";
import NewDiscountPendingTransaction from "pages/discounts/NewDiscountPendingTransaction";
import DetailDiscounts from "pages/discounts/Detail/DetailDiscounts";
import DetailEcheqDiscounts from "pages/discounts/DetailEcheq/DetailEcheqDiscounts";
import MassiveEcheck from "pages/echeck/MassiveEcheck/massiveEcheck";
import DetailThirdPayment from "pages/payThirdParties/Detail/DetailThirdParties";
import MassiveEcheckSummary from "pages/echeck/MassiveEcheck/massiveEcheckSummary";
import SignaturesSchemes from "pages/signaturesScheme/SignaturesScheme";
import EcheckRequestAvalPage from "pages/echeck/SolicitAval/components/SolicitSumaryPage";
import EcheckUpdateAvalPage from "pages/echeck/ActionsAval/components/ActionsSumaryPage";
import MassiveEcheckTransactionPage from "pages/echeck/MassiveEcheck/massiveEcheckTransactionPage";
import RefillsPage from "pages/Refills";
import RefillsConfirmationPage from "pages/Refills/refillsConfirmation";
import ServicePaymentsPage from "pages/servicePayments/ServicePayments";
import NewPaymentPage from "pages/servicePayments/NewServicePayment";
import ServicePaymentSumaryPage from "pages/servicePayments/NewServicePayment/SumaryPage";
import NewPaymentAfip from "pages/afipPayments/Index";
import NewPaymentAfipAccount from "pages/afipPayments/afipAccountSelect";
import NewPaymentAfipSumary from "pages/afipPayments/SummaryPage";
import ServicePaymentsTransactionPage from "pages/servicePayments/TransactionIndex";
import UnsecuredLoanForm from "pages/loans/unsecuredLoans/UnsecuredLoanForm";
import UnsecuredLoanTransactionPage from "pages/loans/unsecuredLoans/UnsecuredLoanTransactionPage";
import AdheredServicesPage from "pages/adheredServices/Index";
import AdheredServicesRemovePage from "pages/adheredServices/RemoveService";
import PaymentsDetailPage from "pages/servicePayments/Detail";
import DetailPayPage from "pages/servicePayments/Detail/PayService";
import CreditBillsPage from "pages/creditBills";
import DetailCreditBillsPage from "pages/creditBills/Detail/DetailCreditBills";
import InformModifyCbu from "pages/creditBills/InformModifyCbu/Index";
import InformModifyCbuSumary from "pages/creditBills/InformModifyCbu/SummaryPage";
import CreditBillsTransactionPage from "pages/creditBills/TransactionIndex";
import TransmitFCEMPage from "pages/creditBills/Transmit";
import TransmitFCEMSummaryPage from "pages/creditBills/Transmit/SummaryPage";
import ActionFCEMPage from "pages/creditBills/BillActions";
import ActionFCEMSummaryPage from "pages/creditBills/BillActions/SummaryPage";
import CashOut from "pages/accounts/cashOut/CashOut";
import CashOutTransactionPage from "pages/accounts/cashOut/CashOutTransactionPage";
import DeclineDebinTransactionPage from "pages/debinPayments/DeclineDebinTransactionPage";
import ManagementCedipPage from "pages/deposits/Cedip/ManagementCedip/ManagementCedipPage";
import RecollectionPage from "pages/Recollection/RecollectionPage";
import CedipDetails from "pages/deposits/Cedip/Detail/CedipDetails";
import TransmitCedip from "pages/deposits/Cedip/CedipActions/TransmitCedip/TransmitCedip";
import CedipConfirmation from "pages/deposits/Cedip/CedipActions/components/CedipConfirmation";
import TransmitCedipSummaryPage from "pages/deposits/Cedip/CedipActions/components/TransactionPage";
import AdmitCedip from "pages/deposits/Cedip/CedipActions/TransmitCedip/AdmitCedip";
import TermsAndConditionsPJ from "pages/environment/StepFinish/TermsAndConditionsPJ";
import VEPPaymentsPage from "pages/afipPaymentLink";
import VepPaymentConfirm from "pages/afipPaymentLink/NewVepPayment/VepPaymentConfirm";
import VepPaymentTransactionPage from "pages/afipPaymentLink/NewVepPayment/VepPaymentTransactionPage";
import PaymentSchedule from "pages/afipPaymentLink/afipServices/paymentSchedule/PaymentSchedule";
import DebtByCuit from "pages/afipPaymentLink/afipServices/debtByCuit/DebtByCuit";
import ServicesPaymentConfirm from "pages/afipPaymentLink/afipServices/newPayment/ServicesPaymentConfirm";
import ServicesPaymentTransactionPage from "pages/afipPaymentLink/afipServices/newPayment/ServicesPaymentTransactionPage";
import ApplyForLoan from "pages/loans/ApplyForLoan";
import CustomLoanForm from "pages/loans/customLoans/CustomLoanForm";
import CustomLoanFormConfirm from "pages/loans/customLoans/CustomLoanFormConfirm";
import CustomLoanTransactionPage from "pages/loans/customLoans/CustomLoanTransactionPage";
import LegalAdvice from "pages/_components/LegalAdvice";
import UnsecuredLoanTokenTermsConditions from "pages/loans/unsecuredLoans/UnsecuredLoanTokenTermsConditions";
import MepTransfer from "pages/transfers/mep";
import MepTransferSummaryPage from "pages/transfers/mep/SummaryPage";
import MepTransactionPage from "pages/transfers/mep/TransactionPage";
import ComexPage from "pages/comex";
import ComexNewContactPage from "pages/comex/contactDestination/NewContact";
import ModifyComexContactPage from "pages/comex/contactDestination/ModifyContact";
import ComexContactDestinationPage from "pages/comex/contactDestination";
import Step1Comex from "pages/comex/Step1Comex";
import Step2Comex from "pages/comex/Step2Comex";
import ComissionList from "pages/comex/CommissionList";
import Step3Comex from "pages/comex/Step3Comex";
import StepTaxRetention from "pages/comex/StepTaxRetention";
import HoldingsDashboard from "pages/investmentFunds/dashboard/HoldingsDashboard";
import InvestorTest from "pages/investmentFunds/investorTest/InvestorTest";
import ProfileInfo from "pages/investmentFunds/investorTest/ProfileInfo";
import NoProfileInfo from "pages/investmentFunds/investorTest/NoProfileInfo";
import StepGeneralDocumentation from "pages/comex/stepGeneralDocumentation/StepGeneralDocumentation";
import StepDDJJGeneral from "pages/comex/stepDDJJGeneral/StepDDJJGeneral";
import ComexTransferSummaryPage from "pages/comex/SummaryPage";
import ListAccounts from "pages/investmentFunds/accounts/ListAccounts";
import ComexTransactionPage from "pages/comex/TransactionPage";
import AccountNoProfile from "pages/investmentFunds/accounts/AccountNoProfile";
import AddAccountForm from "pages/investmentFunds/accounts/AddAccountForm";
import AddAccountFormConfirm from "pages/investmentFunds/accounts/AddAccountFormConfirm";
import StepServiceDocumentation from "pages/comex/stepServiceDocumentation/StepServiceDocumentation";
import StepServicePayment from "pages/comex/stepServicePayment/StepServicePayment";
import AddAccountTransactionPage from "pages/investmentFunds/accounts/AddAccountTransactionPage";
import StepComexClearance from "pages/comex/StepComexClearance/StepComexClearance";
import StepDDJJService from "pages/comex/stepDDJJService/StepDDJJService";
import StepImportPayment from "pages/comex/stepImportPayment/StepImportPayment";
import ListFCIs from "pages/investmentFunds/fci/ListFCIs";
import SwornDeclaration from "pages/investmentFunds/accounts/SwornDeclaration";
import StepGoodsDocumentation from "pages/comex/stepGoodsDocumentation/StepGoodsDocumentation";
import ServicesPayment from "pages/afipPaymentLink/servicesPayment/ServicesPayment";
import Error from "pages/transfers/Error";
import StepDDJJGoods from "pages/comex/stepDDJJGoods/StepDDJJGoods";
import AddService from "pages/afipPaymentLink/servicesPayment/AddService";
import AddServiceConfirm from "pages/afipPaymentLink/servicesPayment/AddServiceConfirm";
import LinkedServiceSummaryPage from "pages/afipPaymentLink/servicesPayment/linkedService/SummaryPage";
import BlackListCashout from "pages/accounts/cashOut/Error";
import NewPayment from "pages/afipPaymentLink/servicesPayment/NewPayment";
import LinkServiceTransactionPage from "pages/afipPaymentLink/servicesPayment/linkedService/LinkServiceTransactionPage";
import NewPaymentConfirm from "pages/afipPaymentLink/servicesPayment/NewPaymentConfirm";
import NewPaymentTransactionPage from "pages/afipPaymentLink/servicesPayment/NewPaymentTransactionPage";
import DirectDebitLoadFile from "pages/directDebit";
import DirectDebitConfirm from "pages/directDebit/DirectDebitConfirm";
import DirectDebitTransactionPage from "pages/directDebit/DirectDebitTransactionPage";
import TransactionPage from "pages/echeck/EcheckActions/TransactionPage";
import ConfirmTransactionEcheckPage from "pages/echeck/EcheckActions/ConfirmTransactionPage";
import DebinChargebackTransactionPage from "pages/debinPayments/ChargeBack/Tickets/DebinChargebackTransactionPage";
import CancelEndorseSummaryPage from "pages/echeck/EndorseEcheck/CancelEndorseSummaryPage";
import RequestCacSummaryPage from "pages/echeck/RequestCac/SummaryPage";
import AcceptReturnRejectedSummaryPage from "pages/echeck/AcceptReturnRejected/SummaryPage";
import AcceptReturnTransactionPage from "pages/echeck/AcceptReturnRejected/TransactionPage";
import RequestCacTransactionPage from "pages/echeck/RequestCac/TransactionPage";
import PayRollLoadFile from "../pages/payroll";
import PayrollConfirm from "../pages/payroll/PayrollConfirm";
import PayrollTransactionPage from "../pages/payroll/PayrollTransactionPage";

class PrivateRoutes extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        hasActiveSession: bool,
        location: shape({
            pathname: string,
        }).isRequired,
    };

    static defaultProps = {
        hasActiveSession: false,
    };

    componentDidMount() {
        const { dispatch, location } = this.props;
        dispatch(statusActions.saveLastHref(location));
    }

    render() {
        const { hasActiveSession } = this.props;

        if (!hasActiveSession) {
            return <Redirect to="/" />;
        }

        return (
            <Fragment>
                <Switch>
                    <DefaultLayout showMenu={false} exact path="/signaturesScheme" component={SignaturesSchemes} />
                    <DefaultLayout exact path="/desktop" component={Desktop} />
                    <DefaultLayout exact path="/environment/stepStart" component={StepStart} withoutLayout />
                    <DefaultLayout
                        exact
                        path="/environment/stepGeneralData"
                        component={StepGeneralData}
                        withoutLayout
                    />
                    <DefaultLayout exact path="/environment/stepTaxData" component={StepTaxData} withoutLayout />
                    <DefaultLayout
                        exact
                        path="/environment/stepLegalRepresentative"
                        component={StepLegalRepresentative}
                        withoutLayout
                    />
                    <DefaultLayout
                        exact
                        path="/environment/stepShareholders"
                        component={StepShareholders}
                        withoutLayout
                    />
                    <DefaultLayout exact path="/environment/stepProxies" component={StepProxies} withoutLayout />
                    <DefaultLayout
                        exact
                        path="/environment/stepBeneficiaries"
                        component={StepBeneficiaries}
                        withoutLayout
                    />
                    <DefaultLayout
                        exact
                        path="/environment/stepDocumentation"
                        component={StepDocumentation}
                        withoutLayout
                    />
                    <DefaultLayout exact path="/environment/stepFinish" component={StepFinish} withoutLayout />
                    {/* eslint-disable-next-line max-len */}
                    <DefaultLayout
                        exact
                        path="/environment/stepFinish/termsAndConditionsPJ"
                        component={TermsAndConditionsPJ}
                    />
                    <DefaultLayout
                        exact
                        path="/environment/stepPaywayFirst"
                        component={StepAcceptPayway}
                        withoutLayout
                    />
                    <DefaultLayout
                        exact
                        path="/environment/stepSelectPaywayTerminalType"
                        component={StepSelectPaywayTerminalType}
                        withoutLayout
                    />
                    <DefaultLayout
                        exact
                        path="/environment/stepSelectPaywayCategory"
                        component={StepSelectPaywayCategory}
                        withoutLayout
                    />
                    <DefaultLayout
                        exact
                        path="/environment/stepSavePaywayTerminalsData"
                        component={StepPaywayTerminals}
                        withoutLayout
                    />
                    <DefaultLayout
                        exact
                        path="/environment/lastStepPayway"
                        component={StepFinishPayway}
                        withoutLayout
                    />
                    <DefaultLayout exact path="/environment/stepError" component={StepError} withoutLayout />
                    <DefaultLayout exact path="/pendingActions" component={PendingActions} withoutLayout />
                    <DefaultLayout exact path="/completePEP" component={StepPEP} withoutLayout />
                    <DefaultLayout exact path="/completeIRS" component={StepIRS} withoutLayout />
                    {/* CARDS */}
                    <DefaultLayout exact path="/creditCards" component={CreditCards} />
                    <DefaultLayout
                        exact
                        path="/creditCards/:id"
                        component={CreditCardDetails}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        exact
                        path="/creditCards/:id/alias"
                        component={CreditCardAliasForm}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/creditCards/:id/filters"
                        component={CreditCardMobileFilters}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/creditCards/:id/filters/results"
                        component={CreditCardMobileFilterResult}
                    />
                    <DefaultLayout
                        exact
                        path="/creditCards/:id/:idStatement"
                        component={CreditrCardMovementDetails}
                        transition="transition-flow-open"
                    />
                    {/* ACCOUNTS */}
                    <DefaultLayout exact path="/accounts" component={AccountsFC} />
                    <DefaultLayout exact path="/accounts/requestForm" component={NewAccountRequestForm} />
                    <DefaultLayout exact path="/accounts/summaryForm" component={NewAccountSummaryForm} />
                    <DefaultLayout exact path="/accounts/pendingTransaction/:id" component={PendingTransactionPage} />
                    <DefaultLayout exact path="/accounts/cancelledTransaction/:id" component={PendingTransactionPage} />
                    <DefaultLayout exact path="/accounts/successTransaction/:id" component={SuccessTransactionPage} />
                    <DefaultLayout exact path="/accounts/failed/:id" component={PendingTransactionPage} />

                    <DefaultLayout
                        exact
                        path="/accounts/:id"
                        component={AccountDetail}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        exact
                        path="/accounts/:id/movement/:id/:tab"
                        component={CustomMovementDetail}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/accounts/:id/setAlias"
                        component={SetAlias}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout exact path="/accounts/:id/statements" component={AccountStatements} />
                    <DefaultLayout
                        exact
                        path="/accounts/:id/filters"
                        component={Filters}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout exact path="/accounts/:id/filters/results" component={Results} />
                    <DefaultLayout
                        exact
                        path="/accounts/:id/agreements"
                        component={Agreements}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/accounts/:id/agreements/request"
                        component={AgreementRequest}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout exact path="/accounts/agreements/summaryForm" component={AgreementSummaryPage} />
                    <DefaultLayout
                        exact
                        path="/accounts/agreements/pendingTransaction/:id"
                        component={PendingAgreementPage}
                    />
                    <DefaultLayout
                        exact
                        path="/accounts/agreements/successTransaction/:id"
                        component={SuccessAgreementPage}
                    />
                    <DefaultLayout
                        exact
                        path="/accounts/agreements/failedTransaction/:id"
                        component={SuccessAgreementPage}
                    />
                    <DefaultLayout
                        exact
                        path="/accounts/:id/historicalBalances"
                        component={HistoricalBalances}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout exact path="/accounts/:id/transfers" component={MobileTransfers} />
                    <DefaultLayout exact path="/cashOut" component={CashOut} />
                    <DefaultLayout exact path="/cashOut/transaction/:id" component={CashOutTransactionPage} />
                    <DefaultLayout exact path="/cashOut/error" component={BlackListCashout} />
                    {/* CHECKS */}
                    <DefaultLayout exact path="/checks/requestCheckbookForm" component={NewCheckbookRequestForm} />
                    <DefaultLayout exact path="/checks/summaryCheckbookForm" component={NewCheckbookSummaryForm} />
                    <DefaultLayout
                        exact
                        path="/checks/pendingBackofficeApprove/:id"
                        component={PendingBackofficeApprovePage}
                    />
                    <DefaultLayout
                        exact
                        path="/checks/pendingUserSignatures/:id"
                        component={PendingUserSignaturesPage}
                    />
                    <DefaultLayout exact path="/checks/successTransaction/:id" component={NewCheckbookSuccessPage} />
                    {/* ECHECK */}
                    <DefaultLayout exact path="/echecks" component={EchecksPage} />
                    <DefaultLayout exact path="/echecks/received/:id" component={DetailEcheck} />
                    <DefaultLayout exact path="/echecks/emitted/:id" component={DetailEcheck} />
                    <DefaultLayout exact path="/echecks/emit" component={EmitEcheckPage} />
                    <DefaultLayout exact path="/echecks/emit/confirm" component={EmitEcheckSummaryPage} />
                    <DefaultLayout exact path="/echecks/emit/pending/:id" component={EmitEcheckTransactionPage} />
                    <DefaultLayout exact path="/echecks/emit/success/:id" component={EmitEcheckTransactionPage} />
                    <DefaultLayout exact path="/echecks/emit/failed/:id" component={EmitEcheckTransactionPage} />
                    <DefaultLayout exact path="/echecks/anulate/confirmation" component={AnulateEcheckPage} />
                    <DefaultLayout exact path="/echecks/action/confirmation" component={ConfirmEcheckPage} />
                    <DefaultLayout exact path="/echecks/action/endorse" component={EndorseEcheckPage} />
                    <DefaultLayout exact path="/echecks/action/endorse/confirm" component={EndorseSummaryPage} />
                    <DefaultLayout
                        exact
                        path="/echecks/action/cancelendorse/confirm"
                        component={CancelEndorseSummaryPage}
                    />
                    <DefaultLayout exact path="/echecks/cac/summary" component={RequestCacSummaryPage} />
                    <DefaultLayout exact path="/echecks/cac/pending/:id" component={RequestCacTransactionPage} />
                    <DefaultLayout exact path="/echecks/cac/success/:id" component={RequestCacTransactionPage} />
                    <DefaultLayout exact path="/echecks/cac/cancelled/:id" component={RequestCacTransactionPage} />
                    <DefaultLayout exact path="/echecks/cac/failed/:id" component={RequestCacTransactionPage} />

                    <DefaultLayout
                        exact
                        path="/echecks/rejected/return/accept"
                        component={AcceptReturnRejectedSummaryPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/rejected/return/accept/failed/:id"
                        component={AcceptReturnTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/rejected/return/accept/pending/:id"
                        component={AcceptReturnTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/rejected/return/accept/cancelled/:id"
                        component={AcceptReturnTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/rejected/return/accept/success/:id"
                        component={AcceptReturnTransactionPage}
                    />

                    <DefaultLayout
                        exact
                        path="/echecks/action/endorse/pending/:id"
                        component={EndorseEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/endorse/success/:id"
                        component={EndorseEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/endorse/failed/:id"
                        component={EndorseEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/endorse/cancelled/:id"
                        component={EndorseEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/transaction/confirm"
                        component={ConfirmTransactionEcheckPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/cancelendorse/success/:id"
                        component={EndorseEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/cancelendorse/failed/:id"
                        component={EndorseEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/cancelendorse/pending/:id"
                        component={EndorseEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/cancelendorse/cancelled/:id"
                        component={EndorseEcheckTransactionPage}
                    />
                    <DefaultLayout exact path="/echecks/action/transaction/pending/:id" component={TransactionPage} />
                    <DefaultLayout exact path="/echecks/action/transaction/success/:id" component={TransactionPage} />
                    <DefaultLayout exact path="/echecks/action/transaction/failed/:id" component={TransactionPage} />
                    <DefaultLayout exact path="/echecks/action/transaction/cancelled/:id" component={TransactionPage} />
                    <DefaultLayout exact path="/echecks/multiple/:status" component={EcheckMultipleTransactionPage} />
                    <DefaultLayout exact path="/echecks/action/cesion" component={EmitCesionPage} />
                    <DefaultLayout exact path="/echecks/action/cesion/confirm" component={CesionSummaryPage} />
                    <DefaultLayout
                        exact
                        path="/echecks/action/cesion/pending/:id"
                        component={CesionEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/cesion/success/:id"
                        component={CesionEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/cesion/transaction/:id"
                        component={CesionEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/cesion/failed/:id"
                        component={CesionEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/action/cesion/cancelled/:id"
                        component={CesionEcheckTransactionPage}
                    />
                    <DefaultLayout exact path="/echeqs/action/return/accept" component={AcceptReturnPage} />
                    <DefaultLayout exact path="/echecks/return/success/:id" component={ReturnTransactionPage} />
                    <DefaultLayout exact path="/echecks/return/pending/:id" component={ReturnTransactionPage} />
                    <DefaultLayout exact path="/echecks/requestAmount" component={EcheckRequestPage} />
                    <DefaultLayout exact path="/echecks/requestAmount/confirm" component={EcheckRequestSummaryPage} />
                    <DefaultLayout
                        exact
                        path="/echecks/requestAmount/pending/:id"
                        component={EcheckRequestTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/requestAmount/success/:id"
                        component={EcheckRequestTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/echecks/requestAmount/cancelled/:id"
                        component={EcheckRequestTransactionPage}
                    />
                    <DefaultLayout exact path="/massiveEchecks" component={MassiveEcheck} />
                    <DefaultLayout exact path="/massiveEchecks/confirm" component={MassiveEcheckSummary} />
                    <DefaultLayout
                        exact
                        path="/massiveEchecks/newEcheq/success/:id"
                        component={MassiveEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/massiveEchecks/newEcheq/pending/:id"
                        component={MassiveEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/massiveEchecks/newEcheq/failed/:id"
                        component={MassiveEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/massiveEchecks/newEcheq/processing/:id"
                        component={MassiveEcheckTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/massiveEchecks/newEcheq/schedule/:id"
                        component={MassiveEcheckTransactionPage}
                    />
                    {/* DISCOUNTS */}
                    <DefaultLayout exact path="/discounts" component={DiscountsPage} />
                    <DefaultLayout exact path="/discounts/simulation" component={DiscountSimulationPage} />
                    <DefaultLayout exact path="/discounts/review" component={DiscountReviewPage} />
                    <DefaultLayout exact path="/discounts/review/:id" component={DiscountReviewPartialsPage} />
                    <DefaultLayout
                        exact
                        path="/discounts/pendingTransaction/:id"
                        component={NewDiscountPendingTransaction}
                    />
                    <DefaultLayout
                        exact
                        path="/discounts/processingTransaction/:id"
                        component={NewDiscountProcessingTransaction}
                    />
                    <DefaultLayout exact path="/discounts/providers/detail/:id" component={DetailDiscounts} />
                    <DefaultLayout exact path="/Discounts/providers/detail/:id" component={DetailDiscounts} />
                    <DefaultLayout
                        exact
                        path="/Discounts/providers/detail/echeq/:id/:echeqNumber"
                        component={DetailEcheqDiscounts}
                    />

                    {/* CONTACTS */}
                    <DefaultLayout exact path="/contactDestination" component={ContactDestinationPage} />
                    <DefaultLayout exact path="/contactDestination/add" component={NewContactPage} />
                    <DefaultLayout exact path="/contactDestination/add/:cbu" component={NewContactPage} />
                    <DefaultLayout exact path="/contactDestination/:id/" component={ContactDetailsPage} />
                    <DefaultLayout exact path="/contactDestination/confirm/:id" component={NewContactSummaryPage} />
                    <DefaultLayout exact path="/contactDestination/success/:id/" component={ContactTransactionPage} />
                    <DefaultLayout exact path="/contactDestination/pending/:id/" component={ContactTransactionPage} />
                    <DefaultLayout exact path="/contactDestination/failed/:id/" component={ContactTransactionPage} />
                    <DefaultLayout exact path="/contactDestination/modify/:id" component={ModifyContactPage} />
                    <DefaultLayout
                        exact
                        path="/contactDestination/:id/modify/confirmation"
                        component={ModifySummaryPage}
                    />
                    <DefaultLayout
                        exact
                        path="/contactDestination/modify/pending/:id"
                        component={ContactTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/contactDestination/modify/success/:id"
                        component={ContactTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/contactDestination/modify/failed/:id"
                        component={ContactTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/contactDestination/:id/delete/confirmation"
                        component={DeleteSummaryPage}
                    />
                    <DefaultLayout
                        exact
                        path="/contactDestination/delete/pending/:id"
                        component={ContactTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/contactDestination/delete/success/:id"
                        component={ContactTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/contactDestination/delete/failed/:id"
                        component={ContactTransactionPage}
                    />
                    {/* TRANSFERS */}
                    <DefaultLayout exact path="/transfers" component={Transfers} />
                    <DefaultLayout exact path="/transfers/:type/confirm" component={TransferSummaryPage} />
                    <DefaultLayout exact path="/transfers/:type/success/:id" component={TransferTransactionPage} />
                    <DefaultLayout exact path="/transfers/:type/pending/:id" component={TransferTransactionPage} />
                    <DefaultLayout exact path="/transfers/:type/failed/:id" component={TransferTransactionPage} />
                    <DefaultLayout exact path="/transfers/:type/schedule/:id" component={TransferTransactionPage} />
                    <DefaultLayout exact path="/transfers/:type/draft/:id" component={TransferTransactionPage} />
                    <DefaultLayout exact path="/transfers/:type/cancelled/:id" component={TransferTransactionPage} />
                    <DefaultLayout exact path="/transfers/error" component={Error} />

                    {/* MEP */}

                    <DefaultLayout exact path="/mep" component={MepTransfer} />
                    <DefaultLayout exact path="/mep/confirm" component={MepTransferSummaryPage} />
                    <DefaultLayout exact path="/mep/transaction/:id" component={MepTransactionPage} />

                    {/* COMEX */}

                    <DefaultLayout exact path="/comex" component={ComexPage} />
                    <DefaultLayout exact path="/comex/contact/add" component={ComexNewContactPage} />
                    <DefaultLayout exact path="/comex/concept" component={Step1Comex} />
                    <DefaultLayout exact path="/comex/payment" component={Step2Comex} />
                    <DefaultLayout exact path="/comex/transfer" component={Step3Comex} />
                    <DefaultLayout exact path="/comex/clearance" component={StepComexClearance} />
                    <DefaultLayout exact path="/comex/goods/paymentdata" component={StepImportPayment} />
                    <DefaultLayout exact path="/comex/retention" component={StepTaxRetention} />
                    <DefaultLayout exact path="/comex/documentation" component={StepGeneralDocumentation} />
                    <DefaultLayout exact path="/comex/goods/documentation" component={StepGoodsDocumentation} />
                    <DefaultLayout exact path="/comex/ddjj/goods" component={StepDDJJGoods} />
                    <DefaultLayout exact path="/comex/ddjj/general" component={StepDDJJGeneral} />
                    <DefaultLayout exact path="/comex/comissions" component={ComissionList} />
                    <DefaultLayout exact path="/comex/confirm" component={ComexTransferSummaryPage} />
                    <DefaultLayout exact path="/comex/transaction/:id" component={ComexTransactionPage} />

                    <DefaultLayout exact path="/comex/service/documentation" component={StepServiceDocumentation} />
                    <DefaultLayout exact path="/comex/service/payment" component={StepServicePayment} />
                    <DefaultLayout exact path="/comex/ddjj/service" component={StepDDJJService} />

                    <DefaultLayout exact path="/comex/contact" component={ComexContactDestinationPage} />
                    <DefaultLayout exact path="/comex/contact/modify/:id" component={ModifyComexContactPage} />

                    {/* DIRECT DEBIT */}

                    <DefaultLayout exact path="/directDebit" component={DirectDebitLoadFile} />
                    <DefaultLayout exact path="/directDebit/confirm" component={DirectDebitConfirm} />
                    <DefaultLayout exact path="/directDebit/transaction/:id" component={DirectDebitTransactionPage} />

                    {/* LOT PAYMENTS */}
                    <DefaultLayout exact path="/lotPayments" component={LotPaymentsPage} />
                    <DefaultLayout exact path="/lotPayments/newPayment" component={NewLotPaymentPage} />
                    <DefaultLayout exact path="/lotPayments/newPayment/confirm" component={NewLotPaymentSummaryPage} />
                    <DefaultLayout
                        exact
                        path="/lotPayments/newPayment/success/:id"
                        component={LotPaymentTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/lotPayments/newPayment/pending/:id"
                        component={LotPaymentTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/lotPayments/newPayment/failed/:id"
                        component={LotPaymentTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/lotPayments/newPayment/processing/:id"
                        component={LotPaymentTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/lotPayments/newPayment/cancelled/:id"
                        component={LotPaymentTransactionPage}
                    />
                    {/* SERVICE PAYMENTS */}
                    <DefaultLayout exact path="/servicePayments" component={ServicePaymentsPage} />
                    <DefaultLayout exact path="/servicePayments/new" component={NewPaymentPage} />
                    <DefaultLayout exact path="/servicePayments/summary" component={ServicePaymentSumaryPage} />
                    <DefaultLayout exact path="/servicePayments/detail/:id/:hash" component={PaymentsDetailPage} />
                    <DefaultLayout exact path="/servicePayments/detail/:id/:hash/pay" component={DetailPayPage} />
                    <DefaultLayout exact path="/recollections" component={RecollectionPage} />

                    {/* REFILLS */}
                    <DefaultLayout exact path="/Payment/refills" component={RefillsPage} />
                    <DefaultLayout exact path="/Payment/refills/confirm" component={RefillsConfirmationPage} />
                    <DefaultLayout
                        exact
                        path="/payments/:type/success/:id"
                        component={ServicePaymentsTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/payments/:type/pending/:id"
                        component={ServicePaymentsTransactionPage}
                    />
                    <DefaultLayout exact path="/payments/:type/failed/:id" component={ServicePaymentsTransactionPage} />
                    {/* AFIP */}
                    <DefaultLayout exact path="/afip/newPayment" component={NewPaymentAfip} />
                    <DefaultLayout exact path="/afip/newPayment/account" component={NewPaymentAfipAccount} />
                    <DefaultLayout exact path="/afip/newPayment/sumary" component={NewPaymentAfipSumary} />
                    {/* Sdhered Services */}
                    <DefaultLayout exact path="/adheredServices/list" component={AdheredServicesPage} />
                    <DefaultLayout exact path="/adheredServices/remove" component={AdheredServicesRemovePage} />

                    {/* PAYMENTS WITH LINK */}
                    <DefaultLayout exact path="/vepPayments" component={VEPPaymentsPage} />
                    <DefaultLayout exact path="/vepPayments/newPayment/confirm" component={VepPaymentConfirm} />
                    <DefaultLayout
                        exact
                        path="/vepPayments/newPayment/transaction/:id"
                        component={VepPaymentTransactionPage}
                    />
                    <DefaultLayout exact path="/arcaPaymentSchedule" component={PaymentSchedule} />
                    <DefaultLayout exact path="/arcaServices/newPayment" component={DebtByCuit} />
                    <DefaultLayout exact path="/arcaServices/newPayment/confirm" component={ServicesPaymentConfirm} />
                    <DefaultLayout
                        exact
                        path="/arcaServices/newPayment/transaction/:id"
                        component={ServicesPaymentTransactionPage}
                    />
                    <DefaultLayout exact path="/servicesPayment" component={ServicesPayment} />
                    <DefaultLayout exact path="/addService" component={AddService} />
                    <DefaultLayout exact path="/addService/confirm" component={AddServiceConfirm} />
                    <DefaultLayout exact path="/newServicePayment" component={NewPayment} />
                    <DefaultLayout exact path="/newServicePayment/confirm" component={NewPaymentConfirm} />
                    <DefaultLayout
                        exact
                        path="/newServicePayment/transaction/:id"
                        component={NewPaymentTransactionPage}
                    />
                    <DefaultLayout exact path="/servicePayments/linkedServices" component={LinkedServiceSummaryPage} />
                    <DefaultLayout exact path="/linkService/transaction/:id" component={LinkServiceTransactionPage} />

                    {/* BILLS */}
                    <DefaultLayout exact path="/creditBills" component={CreditBillsPage} />
                    <DefaultLayout exact path="/creditBills/detail/:id/:type" component={DetailCreditBillsPage} />
                    <DefaultLayout exact path="/creditBills/inform/modify" component={InformModifyCbu} />
                    <DefaultLayout exact path="/creditBills/inform/sumary" component={InformModifyCbuSumary} />
                    <DefaultLayout exact path="/creditBills/transmission" component={TransmitFCEMPage} />
                    <DefaultLayout exact path="/creditBills/transmission/confirm" component={TransmitFCEMSummaryPage} />
                    <DefaultLayout exact path="/creditBills/:action" component={ActionFCEMPage} />
                    <DefaultLayout exact path="/creditBills/:action/confirm" component={ActionFCEMSummaryPage} />

                    <DefaultLayout
                        exact
                        path="/creditBills/:action/pending/:id"
                        component={CreditBillsTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/creditBills/:action/success/:id"
                        component={CreditBillsTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/creditBills/:action/failed/:id"
                        component={CreditBillsTransactionPage}
                    />
                    {/* SETTINGS */}
                    <DefaultLayout exact path="/settings" component={Settings} />
                    <DefaultLayout
                        exact
                        path="/settings/changePassword"
                        component={ChangePassword}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changeSecuritySeal"
                        component={ChangeSecuritySeal}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changeSecuritySeal/confirmation"
                        component={ChangeSecuritySealConfirmation}
                    />
                    <DefaultLayout
                        exact
                        path="/settings/notificationsConfiguration"
                        component={NotificationsConfiguration}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        path="/settings/notificationsConfiguration/:communicationType"
                        component={NotificationsConfigurationTransports}
                    />
                    <DefaultLayout
                        exact
                        path="/settings/fingerprintConfiguration"
                        component={FingerprintConfiguration}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/fingerprintConfiguration/deleteConfirmation"
                        component={FingerprintDeleteConfirmation}
                    />
                    <DefaultLayout
                        exact
                        path="/settings/pushNotifications"
                        component={PushNotifications}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/myDevices"
                        component={MyDevices}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/myToken"
                        component={MyToken}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/queryToken"
                        component={QueryToken}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/esign/documents"
                        component={DocumentsIndex}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/esign/documentsSigned"
                        component={EsignDocumentsSigned}
                        transition="transition-flow-open"
                    />

                    <DefaultLayout
                        exact
                        path="/settings/pushNotifications/deleteConfirmation"
                        component={PushNotificationsDeleteConfirmation}
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changeEnvironment"
                        component={ChangeEnvironment}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/setDefaultEnvironment"
                        component={SetDefaultEnvironment}
                        transition="transition-flow-open"
                    />

                    <DefaultLayout
                        exact
                        path="/settings/changeEmail"
                        component={ChangeEmail}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changeEmail/confirmation"
                        component={ChangeEmailConfirmation}
                    />

                    <DefaultLayout
                        exact
                        path="/settings/changePhone"
                        component={ChangePhone}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/settings/changePhone/confirmation"
                        component={ChangePhoneConfirmation}
                    />
                    <DefaultLayout exact path="/settings/LastLogin" component={LastLogin} />
                    {/* LOANS */}
                    <DefaultLayout exact path="/loans" component={Loans} />
                    <DefaultLayout exact path="/loans/solicitud" component={SolicitudDatos} />
                    <DefaultLayout exact path="/loans/otrosProductos" component={OtrosProductos} />

                    <DefaultLayout exact path="/loans/detallePrestamo/:id" component={DetallePrestamo} />
                    <DefaultLayout exact path="/loans/detalleCuota/:id/:cuota" component={DetalleCuota} />
                    <DefaultLayout exact path="/loans/cancelacionAnticipada/:id" component={CancelacionAnticipada} />
                    <DefaultLayout
                        exact
                        path="/loans/cancelacionAnticipadaTicket/:id"
                        component={CancelacionAnticipadaTicket}
                    />
                    <DefaultLayout
                        exact
                        path="/loans/otrosProductosSucccessTicket/:id"
                        component={OtrosProductosSuccessTicket}
                    />

                    <DefaultLayout exact path="/loans/:id/" component={LoanDetails} transition="transition-drill-in" />
                    <DefaultLayout
                        exact
                        path="/loans/:id/setAlias"
                        component={LoanSetAlias}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/loans/:id/statement"
                        component={LoanStatementDetail}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/loans/:id/filters"
                        component={LoanMobileFilters}
                        transition="transition-flow-open"
                    />
                    {/* DEPOSITS */}
                    <DefaultLayout exact path="/deposits" component={Deposits} />
                    <DefaultLayout exact path="/deposits/requestForm" component={NewDepositRequestForm} />
                    <DefaultLayout exact path="/deposits/summaryForm" component={NewDepositSummaryForm} />
                    <DefaultLayout
                        exact
                        path="/deposits/pendingTransaction/:id"
                        component={NewDepositPendingTransaction}
                    />
                    <DefaultLayout
                        exact
                        path="/deposits/successTransaction/:id"
                        component={NewDepositSuccessTransaction}
                    />
                    <DefaultLayout
                        exact
                        path="/deposits/failedTransaction/:id"
                        component={NewDepositSuccessTransaction}
                    />
                    <DefaultLayout
                        exact
                        path="/deposits/cancelRenewal/forbiden/:id"
                        component={ForbidenCancelRenewalPage}
                    />
                    <DefaultLayout exact path="/deposits/cancelRenewal/:id" component={DepositCancelRenewal} />
                    <DefaultLayout exact path="/deposits/rates" component={DepositRates} />
                    <DefaultLayout
                        exact
                        path="/deposits/:id"
                        component={DepositDetails}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout exact path="/deposits/:id/cancelRenewal" component={DepositCancelRenewal} />
                    <DefaultLayout
                        exact
                        path="/deposits/historical/:id"
                        component={HistoricalDetails}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        exact
                        path="/deposits/cancelRenewal/successTransaction/:id"
                        component={SuccessCancelRenewalPage}
                    />
                    <DefaultLayout
                        exact
                        path="/deposits/cancelRenewal/pendingTransaction/:id"
                        component={PendingCancelRenewalPage}
                    />
                    {/* FORMS */}
                    <DefaultLayout exact path="/form/:idForm" component={Form} transition="transition-flow-open" />
                    <DefaultLayout
                        path="/transaction/:idTransaction"
                        component={Transaction}
                        transition="transition-flow-open"
                        exact
                    />
                    <DefaultLayout
                        path="/form/:idForm/processDetail"
                        component={FormPaymentLines}
                        transition="transition-drill-in"
                        componentProps={{ isConfirmation: true }}
                    />
                    <DefaultLayout
                        path="/transaction/:idTransaction/processDetail"
                        component={TransactionPaymentLines}
                        transition="transition-drill-in"
                    />
                    {/* CEDIP */}
                    <DefaultLayout exact path="/depositsCedip" component={ManagementCedipPage} />
                    <DefaultLayout
                        exact
                        path="/depositsCedip/:id"
                        component={CedipDetails}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        exact
                        path="/depositsCedip/transmit/:id"
                        component={TransmitCedip}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        exact
                        path="/depositsCedip/admit/:id"
                        component={AdmitCedip}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout
                        exact
                        path="/cedip/transmit/confirmation"
                        component={CedipConfirmation}
                        transition="transition-drill-in"
                    />
                    <DefaultLayout exact path="/cedip/transmit/pending/:id" component={TransmitCedipSummaryPage} />
                    <DefaultLayout exact path="/cedip/transmit/success/:id" component={TransmitCedipSummaryPage} />
                    <DefaultLayout exact path="/cedip/transmit/failed/:id" component={TransmitCedipSummaryPage} />
                    {/* PAYMENT LISTS */}
                    <DefaultLayout path="/creditCardsPayment/list" component={CreditCardsPaymentList} />
                    <DefaultLayout path="/loansPayment/list" component={LoansPaymentList} />
                    {/* MANUAL MASS PAYMENT */}
                    <DefaultLayout
                        path="/form/:idForm/manual"
                        component={FormPaymentLines}
                        transition="transition-drill-in"
                    />
                    {/* COMMUNICATIONS */}
                    <DefaultLayout exact path="/communications" component={CommunicationMain} />
                    <DefaultLayout
                        exact
                        path="/environment/communications"
                        component={CommunicationMain}
                        withoutLayout
                    />
                    <DefaultLayout
                        exact
                        path="/communications/compose"
                        component={NewMessage}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout exact path="/communications/reply/:id" component={ReplyMessage} />
                    <DefaultLayout
                        exact
                        path="/communications/read/:id"
                        component={ReadMessage}
                        transition="transition-flow-open"
                    />
                    {/* TRANSACTIONS */}
                    <DefaultLayout exact path="/transactions/list" component={TransactionsList} />
                    <DefaultLayout exact path="/pendingTransaction/list" component={PendingTransactionList} />
                    <DefaultLayout
                        exact
                        path="/transactions/list/filters"
                        component={TransactionsListFilters}
                        transition="transition-flow-open"
                    />
                    <DefaultLayout
                        exact
                        path="/transactions/list/filters/results"
                        component={TransactionsFiltersResults}
                    />
                    <DefaultLayout path="/form/:formId/bankSearch/:fieldId" component={BankSearch} />
                    <DefaultLayout path="/form/:formId/templates" component={Templates} />
                    {/* EXTERNAL */}
                    <DefaultLayout exact path="/privacyPolicy" component={PrivacyPolicy} />
                    <DefaultLayout exact path="/termsAndConditions" component={TermsAndConditions} />
                    <DefaultLayout exact path="/support" component={SupportInfo} />
                    <DefaultLayout exact path="/legalAdvice" component={LegalAdvice} />
                    {/* administration */}
                    <DefaultLayout exact path="/administration/users/invite" component={UserInvite} />
                    <DefaultLayout exact path="/administration/users/inviteStep2" component={UserInviteStep2} />
                    <DefaultLayout exact path="/administration/users/inviteStep3" component={UserInviteStep3} />
                    <DefaultLayout
                        exact
                        path="/administration/medium/signature/:idTransaction/ticket"
                        component={AdministrationMediumSignatureTicket}
                    />
                    <DefaultLayout exact path="/settings/pointsOfInterest" component={PointsOfInterest} />
                    <DefaultLayout path="/administration" component={Administration} />
                    {/* end of administration */}
                    {/* DEBIN */}
                    <DefaultLayout exact path="/debinPayments" component={DebinPayments} />
                    <DefaultLayout exact path="/debinPayments/AddRecurence" component={AddRecurenceDebin} />
                    <DefaultLayout exact path="/debin/AddRecurence/confirm" component={DebinConfirmePage} />
                    <DefaultLayout exact path="/debin/emit/pending/:id" component={EmitDebinTransactionPage} />
                    <DefaultLayout exact path="/debin/emit/success/:id" component={EmitDebinTransactionPage} />
                    <DefaultLayout exact path="/debin/emit/failed/:id" component={EmitDebinTransactionPage} />
                    <DefaultLayout exact path="/debinPayments/action/received" component={ReceivedDebinSumaryPage} />
                    <DefaultLayout exact path="/debinPayments/action/reject" component={RejectDebinSumaryPage} />
                    <DefaultLayout exact path="/debinPayments/action/anulate" component={AnulateDebinSumaryPage} />
                    <DefaultLayout exact path="/debin/recurent/detail/:id" component={DetailRecurrentDebin} />
                    <DefaultLayout exact path="/debin/recived/detail/:id" component={DetailReceibedDebin} />
                    <DefaultLayout exact path="/debin/issued/detail/:id" component={DetailIssuedDebin} />

                    <DefaultLayout exact path="/debin/chargeBack" component={ChargeBackSummaryPage} />
                    <DefaultLayout
                        exact
                        path="/debin/chargeBack/pending/:id"
                        component={DebinChargebackTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/debin/chargeBack/failed/:id"
                        component={DebinChargebackTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/debin/chargeBack/cancelled/:id"
                        component={DebinChargebackTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/debin/chargeBack/failed/:id"
                        component={DebinChargebackTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/debin/chargeBack/success/:id"
                        component={DebinChargebackTransactionPage}
                    />

                    <DefaultLayout exact path="/debinPayments/action/action" component={ActionsDebinSumaryPage} />
                    <DefaultLayout
                        exact
                        path="/debinPayments/action/action/pending/:id"
                        component={ActionsTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/debinPayments/action/action/success/:id"
                        component={ActionsTransactionPage}
                    />
                    <DefaultLayout exact path="/debinPayments/addAccount" component={AddAccountDebin} />
                    <DefaultLayout exact path="/debinPayments/addAccount/:id" component={AddAccountConfirmation} />
                    <DefaultLayout exact path="/debinPayments/solicitDebin" component={SolicitDebin} />
                    <DefaultLayout
                        exact
                        path="/debinPayments/solicitDebin/confimation"
                        component={SolicitDebinConfirmation}
                    />
                    <DefaultLayout
                        exact
                        path="/debinPayments/solicitDebin/success/:id/"
                        component={SolicitDebinTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/debinPayments/solicitDebin/pending/:id/"
                        component={SolicitDebinTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/debinPayments/solicitDebin/failed/:id/"
                        component={SolicitDebinTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/debinPayments/reject/success/:id"
                        component={DeclineDebinTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/debinPayments/reject/pending/:id"
                        component={DeclineDebinTransactionPage}
                    />
                    <DefaultLayout
                        exact
                        path="/debinPayments/reject/failed/:id"
                        component={DeclineDebinTransactionPage}
                    />
                    <DefaultLayout exact path="/debinPayments/pay/success/:id/" component={payDebinPage} />
                    <DefaultLayout exact path="/debinPayments/pay/pending/:id/" component={payDebinPage} />
                    <DefaultLayout exact path="/debinPayments/pay/failed/:id/" component={payDebinPage} />
                    <DefaultLayout exact path="/scheduledDebin" component={ScheduledDebinList} />
                    <DefaultLayout exact path="/scheduledDebin/action/:action" component={ActionConfirmation} />
                    <DefaultLayout
                        exact
                        path="/scheduledDebin/:action/transaction/:id"
                        component={ActionTransactionPage}
                    />
                    <DefaultLayout exact path="/scheduledDebin/detail/:id" component={ScheduledDebinDetail} />

                    {/* AVAL */}
                    <DefaultLayout exact path="/echecks/aval/solicit" component={SolicitAval} />
                    <DefaultLayout exact path="/echecks/aval/solicit/sumary" component={SolicitAvalSumary} />
                    <DefaultLayout exact path="/echecks/aval/actions/sumary" component={ActionsAvalPage} />
                    <DefaultLayout exact path="/echecks/aval/solicit/pending/:id" component={EcheckRequestAvalPage} />
                    <DefaultLayout exact path="/echecks/aval/solicit/success/:id" component={EcheckRequestAvalPage} />
                    <DefaultLayout exact path="/echecks/aval/solicit/failed/:id" component={EcheckRequestAvalPage} />
                    <DefaultLayout exact path="/echecks/aval/update/pending/:id" component={EcheckUpdateAvalPage} />
                    <DefaultLayout exact path="/echecks/aval/update/success/:id" component={EcheckUpdateAvalPage} />
                    <DefaultLayout exact path="/echecks/aval/update/failed/:id" component={EcheckUpdateAvalPage} />
                    {/* ThirdPayment */}
                    <DefaultLayout exact path="/ThirdPayment/providers/detail/:id" component={DetailThirdPayment} />
                    {/* Unsecured loan */}
                    <DefaultLayout exact path="/applyForLoan" component={ApplyForLoan} />
                    <DefaultLayout exact path="/requestUnsecuredLoan" component={UnsecuredLoanForm} />
                    <DefaultLayout
                        exact
                        path="/requestUnsecuredLoan/transaction/:id"
                        component={UnsecuredLoanTransactionPage}
                    />
                    <DefaultLayout exact path="/requestCustomLoan" component={CustomLoanForm} />
                    <DefaultLayout exact path="/requestCustomLoan/confirm" component={CustomLoanFormConfirm} />
                    <DefaultLayout
                        exact
                        path="/requestUnsecuredLoan/confirm"
                        component={UnsecuredLoanTokenTermsConditions}
                    />
                    <DefaultLayout
                        exact
                        path="/requestCustomLoan/transaction/:id"
                        component={CustomLoanTransactionPage}
                    />
                    {/* INVERSIONES */}
                    <DefaultLayout exact path="/holdings" component={HoldingsDashboard} />
                    <DefaultLayout exact path="/investorTest" component={InvestorTest} />
                    <DefaultLayout exact path="/profileInfo" component={ProfileInfo} />
                    <DefaultLayout exact path="/noProfileInfo" component={NoProfileInfo} />
                    <DefaultLayout exact path="/investmentFunds/listAccounts" component={ListAccounts} />
                    <DefaultLayout exact path="/investmentFunds/accounts/noProfileInfo" component={AccountNoProfile} />
                    <DefaultLayout exact path="/investmentFunds/accounts/add" component={AddAccountForm} />
                    <DefaultLayout
                        exact
                        path="/investmentFunds/accounts/add/confirm"
                        component={AddAccountFormConfirm}
                    />
                    <DefaultLayout
                        exact
                        path="/investmentFunds/accounts/add/transaction/:id"
                        component={AddAccountTransactionPage}
                    />
                    <DefaultLayout exact path="/investmentFunds/fci/list" component={ListFCIs} />
                    <DefaultLayout exact path="/investmentFunds/accounts/add/ddjj" component={SwornDeclaration} />

                    {/* MASS PAYROLL PAYMENT */}

                    <DefaultLayout exact path="/massPayroll" component={PayRollLoadFile} />
                    <DefaultLayout exact path="/massPayroll/confirm" component={PayrollConfirm} />
                    <DefaultLayout exact path="/massPayroll/transaction/:id" component={PayrollTransactionPage} />
                </Switch>
                <BackButtonListener />
                <Route path="/" component={SessionAboutToExpire} />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    hasActiveSession: sessionSelectors.isLoggedIn(state),
});

export default withRouter(connect(mapStateToProps)(PrivateRoutes));
